import { useEffect, useState } from "react";
import QRCodeSVG from "qrcode.react";
import styled from "styled-components";
import { useAxios } from "../../../axiosProvider";

//-------------------------------------------------------------------------------------

const Container = styled.div`
  flex: 1;
  margin-top: 3px;

  .icon {
    font-size: 14px;
    color: #636363;
  }

  .spinner {
    animation: spin 1s linear infinite;
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;

//-------------------------------------------------------------------------------------

const CustomQrCode = ({ phoneNumberOrEmail, messageBody, platform }) => {
  const [shortUrl, setShortUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { axiosInstance } = useAxios();

  const smsUrl = `sms:${phoneNumberOrEmail}&body=${messageBody
    .split("\n")
    .map((line) => encodeURIComponent(line))
    .join("%0A")}`;

  const whatsappUrl = `whatsapp://send?text=${messageBody
    .split("\n")
    .map((line) => encodeURIComponent(line))
    .join("%0A")}&phone=+${phoneNumberOrEmail}&abid=+${phoneNumberOrEmail}`;
  const viberUrl = `viber://chat?number=${phoneNumberOrEmail}&draft=${messageBody
    .split("\n")
    .map((line) => encodeURIComponent(line))
    .join("%0A")}`;
  const mailtoUrl = `mailto:${phoneNumberOrEmail}?subject=${encodeURIComponent(
    "GETAWAYS GREECE - IMPORTANT INFORMATION ABOUT YOUR TOUR"
  )}&body=${messageBody
    .split("\n")
    .map((line) => encodeURIComponent(line))
    .join("%0A")}`;

  useEffect(() => {
    const shortenUrl = async () => {
      try {
        setIsLoading(true);
        const targetUrl =
          platform === "sms"
            ? smsUrl
            : platform === "whatsapp"
            ? whatsappUrl
            : platform === "viber"
            ? viberUrl
            : mailtoUrl;

        const response = await axiosInstance.post("api/short_urls", {
          url: targetUrl,
        });

        setShortUrl(response.data.short_url);
        setIsLoading(false);
      } catch (error) {
        console.error("Error shortening URL:", error);
        setIsLoading(false);
      }
    };

    shortenUrl();
  }, [
    axiosInstance,
    smsUrl,
    platform,
    whatsappUrl,
    viberUrl,
    mailtoUrl,
  ]);

  return (
    <Container>
      {isLoading ? (
        <i
          style={{
            fontSize: "15px",

            color: "white",
          }}
          className="fa-solid fa-circle-notch spinner icon"
        ></i>
      ) : (
        <QRCodeSVG
          size={100}
          style={{
            height: "100%",
            maxWidth: "100%",
            width: "100%",
            backgroundColor: "white",
            padding: "3px",
            borderRadius: "5px",
          }}
          value={shortUrl}
        />
      )}
    </Container>
  );
};

export default CustomQrCode;
